var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"enter-active-class":"animated-field fast slideInDown","leave-active-class":"animated-field fast slideOutUp"}},[(_vm.isActive)?_c('div',{staticClass:"msg-header"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }